export default {
  errorDefault: 'Ett fel inträffade',
  unknown: 'Okänd',
};
